/* eslint-disable import/prefer-default-export */
export function getComponent(key, props) {
  const { children } = props;
  return children.filter(component => component.key === key);
}
